import { render, staticRenderFns } from "./CollectionForm.vue?vue&type=template&id=d8d8d7f6&"
import script from "./CollectionForm.vue?vue&type=script&lang=js&"
export * from "./CollectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports